import { Box as MuiBox } from "@mui/material";

export function Box(props: any) {
  return <MuiBox {...props} />;
}
